import React from 'react';
import { Button, Card, Col, Form, Input, Row, Space, Typography } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useAuth } from 'contexts/auth';
import { useApp } from 'contexts/app';
import AccountService from 'services/account';

const { Text } = Typography;
const accountService = new AccountService();

const AccountInfo = () => {
    const { user } = useAuth();
    const { showLoading, showNotify, message } = useApp();
    const [changePassForm] = useForm();

    const onChangePassword = async () => {
        const values = changePassForm.getFieldsValue();
        showLoading(true);
        try {
            await accountService.changePass({
                old_pass: values.old_pass,
                new_pass: values.new_pass,
            });
            showNotify('Đổi mật khẩu thành công');
            changePassForm.resetFields();
        } catch (error) {
            message.error(error?.message || 'Không thể đổi mật khẩu');
        }
        showLoading(false);
    };

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Card title="Thông tin tài khoản" style={{ width: '100%' }}>
                <Row gutter={[16, 12]}>
                    <Col span={24}>
                        <Text strong>Họ tên: </Text>
                        <Text>{user?.full_name || '-'}</Text>
                    </Col>
                    <Col span={24}>
                        <Text strong>Vai trò: </Text>
                        <Text>{user?.work_space?.role || '-'}</Text>
                    </Col>
                    <Col span={24}>
                        <Text strong>Shop: </Text>
                        <Text>{user?.work_space?.name || '-'}</Text>
                    </Col>
                </Row>
            </Card>

            <Card title="Đổi mật khẩu" style={{ width: '100%' }}>
                <Form layout="vertical" form={changePassForm} onFinish={onChangePassword}>
                    <Form.Item
                        label="Mật khẩu hiện tại"
                        name="old_pass"
                        rules={[{ required: true, message: 'Bạn phải nhập mật khẩu hiện tại' }]}
                    >
                        <Input.Password placeholder="Mật khẩu hiện tại"></Input.Password>
                    </Form.Item>

                    <Form.Item
                        label="Mật khẩu mới"
                        name="new_pass"
                        rules={[{ required: true, message: 'Bạn phải nhập mật khẩu mới' }]}
                    >
                        <Input.Password placeholder="Mật khẩu mới"></Input.Password>
                    </Form.Item>

                    <Form.Item
                        label="Nhập lại mật khẩu mới"
                        name="re_new_pass"
                        dependencies={['new_pass']}
                        rules={[
                            { required: true, message: 'Bạn phải nhập lại mật khẩu mới' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('new_pass') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Mật khẩu nhập lại không khớp'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="Nhập lại mật khẩu mới"></Input.Password>
                    </Form.Item>

                    <Button type="primary" onClick={() => changePassForm.submit()}>
                        Cập nhật mật khẩu
                    </Button>
                </Form>
            </Card>
        </Space>
    );
};

export default AccountInfo;
